import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { COOKIE_MODAL_CLOSED_EVENT, GLOBALS, ONETRUST_GROUPS_UPDATED_EVENT, getCanonicalLocale, getDynatraceConsentPaths, getOneTrustConfigByLocale, isOneTrustCookieConsentActive, syncDynatraceConsentFromCookie, syncDynatraceConsentFromOneTrust } from '@whitbread-eos/utils';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useEffect } from 'react';
import AmazonChatIcon from '../AmazonChatIcon';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function ScriptsEmbed(_ref) {
  var isAmazonChatBoxEnabled = _ref.isAmazonChatBoxEnabled,
    language = _ref.language,
    locale = _ref.locale,
    amazonChatIcon = _ref.amazonChatIcon,
    isOneTrustCookieConsentEnabled = _ref.isOneTrustCookieConsentEnabled,
    _ref$isDynatraceRumCo = _ref.isDynatraceRumCookieConsentEnabled,
    isDynatraceRumCookieConsentEnabled = _ref$isDynatraceRumCo === void 0 ? false : _ref$isDynatraceRumCo;
  var _useRouter = useRouter(),
    pathname = _useRouter.pathname;
  var includeAdobeScript = !pathname.includes('opera-shared-page');
  var _getConfig = getConfig(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;
  var amazonChatUrl = publicRuntimeConfig.NEXT_PUBLIC_AMAZON_CHAT_URL_GB;
  var amazonChatId = publicRuntimeConfig.NEXT_PUBLIC_AMAZON_CHAT_ID_GB;
  var dtScript = language === GLOBALS.language.EN ? process.env.NEXT_PUBLIC_DYNATRACE_GB : process.env.NEXT_PUBLIC_DYNATRACE_DE;
  if (language === GLOBALS.language.DE) {
    amazonChatUrl = publicRuntimeConfig.NEXT_PUBLIC_AMAZON_CHAT_URL_DE;
    amazonChatId = publicRuntimeConfig.NEXT_PUBLIC_AMAZON_CHAT_ID_DE;
  }
  var oneTrustLocale = getCanonicalLocale(locale !== null && locale !== void 0 ? locale : language);
  var oneTrustConfig = getOneTrustConfigByLocale(oneTrustLocale);
  var isOneTrustActive = isOneTrustCookieConsentActive(isOneTrustCookieConsentEnabled, locale !== null && locale !== void 0 ? locale : language);
  useEffect(() => {
    if (!isAmazonChatBoxEnabled) {
      removeAmazonChatWidget();
    }
  }, [isAmazonChatBoxEnabled]);
  useEffect(() => {
    if (isOneTrustActive) {
      return;
    }
    var syncFromCustomCookie = () => {
      var _split = (locale !== null && locale !== void 0 ? locale : '').split('-'),
        _split2 = _slicedToArray(_split, 2),
        localeLanguage = _split2[0],
        localeCountry = _split2[1];
      var customCookiePaths = localeLanguage && localeCountry ? getDynatraceConsentPaths(localeLanguage, localeCountry) : ['/'];
      syncDynatraceConsentFromCookie({
        isEnabled: isDynatraceRumCookieConsentEnabled,
        paths: customCookiePaths,
        domain: process.env.NEXT_PUBLIC_COOKIES_DOMAIN
      });
    };
    syncFromCustomCookie();
    window.addEventListener(COOKIE_MODAL_CLOSED_EVENT, syncFromCustomCookie);
    return () => {
      window.removeEventListener(COOKIE_MODAL_CLOSED_EVENT, syncFromCustomCookie);
    };
  }, [isDynatraceRumCookieConsentEnabled, isOneTrustActive, locale]);
  function removeAmazonChatWidget() {
    document.querySelectorAll('#amazon-connect-chat-widget').forEach(el => el.remove());
  }
  return _jsxs(_Fragment, {
    children: [includeAdobeScript && _jsx(Script, {
      src: "//assets.adobedtm.com/launch-EN1f330bc46c5949b29c22bbf3f0573f75.min.js",
      strategy: "beforeInteractive",
      "data-testid": "adobe-script"
    }), dtScript && _jsx(Script, {
      src: dtScript,
      "data-testid": "dynatrace-script",
      strategy: "beforeInteractive",
      defer: false
    }), isAmazonChatBoxEnabled && _jsxs(_Fragment, {
      children: [amazonChatIcon && _jsx(AmazonChatIcon, {
        amazonChatIcon: amazonChatIcon
      }), _jsx(Script, {
        src: amazonChatUrl,
        id: amazonChatId,
        async: true,
        defer: false
      })]
    }), isOneTrustActive && _jsx(OneTrustConsentScripts, {
      scriptUrl: process.env.NEXT_PUBLIC_ONE_TRUST_SCRIPT_URL,
      dataLanguage: oneTrustConfig.dataLanguage,
      domainScript: oneTrustConfig.domainScript,
      isDynatraceRumCookieConsentEnabled: isDynatraceRumCookieConsentEnabled
    })]
  });
}
function OneTrustConsentScripts(_ref2) {
  var scriptUrl = _ref2.scriptUrl,
    dataLanguage = _ref2.dataLanguage,
    domainScript = _ref2.domainScript,
    isDynatraceRumCookieConsentEnabled = _ref2.isDynatraceRumCookieConsentEnabled;
  useEffect(() => {
    var syncConsent = () => syncDynatraceConsentFromOneTrust({
      isEnabled: isDynatraceRumCookieConsentEnabled
    });
    window.addEventListener(ONETRUST_GROUPS_UPDATED_EVENT, syncConsent);
    syncConsent();
    return () => {
      window.removeEventListener(ONETRUST_GROUPS_UPDATED_EVENT, syncConsent);
    };
  }, [isDynatraceRumCookieConsentEnabled]);
  return _jsxs(_Fragment, {
    children: [_jsx(Script, {
      src: scriptUrl,
      "data-document-language": "true",
      "data-language": dataLanguage,
      type: "text/javascript",
      "data-domain-script": domainScript,
      strategy: "beforeInteractive",
      "data-testid": "one-trust-cookie-consent"
    }), _jsx(Script, {
      id: "optanon-wrapper",
      strategy: "beforeInteractive",
      children: "function OptanonWrapper() {}"
    })]
  });
}